import React from "react"
import { Button, Dropdown } from "@mimber/ui-web"
import { EyeOutlined } from "@mimber/ui-web"
import { CommunicationChannel } from "@mimber/schema"
import { AnnouncementPreviewModal } from "./AnnouncementPreviewModal"
import { CHANNEL_LABEL } from "./AnnouncementPreviewModal.utils"
import type { AnnouncementPreviewButtonProps } from "./AnnouncementPreviewButton.types"

export const AnnouncementPreviewButton: React.FunctionComponent<
  AnnouncementPreviewButtonProps
> = ({ emailTemplateUuid, smsTemplateUuid, pushTemplateUuid, disabled }) => {
  const templateMap: Record<CommunicationChannel, string | null | undefined> = {
    [CommunicationChannel.EMAIL]: emailTemplateUuid,
    [CommunicationChannel.SMS]: smsTemplateUuid,
    [CommunicationChannel.PUSH]: pushTemplateUuid,
  }

  const hasAnyTemplate = Object.values(templateMap).some(Boolean)

  const items = Object.values(CommunicationChannel).map((channel) => {
    const uuid = templateMap[channel]
    return {
      key: channel,
      disabled: !uuid,
      label: uuid ? (
        <AnnouncementPreviewModal
          templateUuid={uuid}
          channel={channel}
          renderButton={(open) => (
            <span onClick={open}>{CHANNEL_LABEL[channel]}</span>
          )}
        />
      ) : (
        CHANNEL_LABEL[channel]
      ),
    }
  })

  return (
    <Dropdown
      menu={{ items }}
      trigger={["click"]}
      disabled={disabled || !hasAnyTemplate}
    >
      <Button icon={<EyeOutlined />} disabled={disabled || !hasAnyTemplate}>
        Preview
      </Button>
    </Dropdown>
  )
}
